export const environmentPath = '/environment.json';
export const fetchEnvironment = async () => {
    const response = await fetch(environmentPath);
    return response.json();
};
